<template>
  <sui-form-field :width="field.width || 16" :error="isInvalid">
    <label v-show="field.label">
      {{field.label}}
    </label>
    <sui-input v-model.number="$attrs.value" type="number" min="1" max="65535" :icon="icon" :placeholder="field.placeholder" @input="onInput" />
    <small class="errors">
      {{error}}
    </small>
  </sui-form-field>
</template>

<script>
  import FormField from '@/mixins/FormField'

  export default {
    name: 'FormProviderPort',
    mixins: [
      FormField,
    ],
  }
</script>

<style scoped>
  .errors { display: none; color: #9f3a38; }
  .error > .errors { display: block; }
</style>
